import React , {useEffect, useState} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Routes,
  Route,
  useLocation
} from "react-router-dom";

import { PublicRoutes } from './routes/public';
import { PrivateRoutes } from './routes/private';
import { ALERT_TYPE, ShowToastMessage, useSessionHandoff } from '@laramie/ui';
import PublicRoute from './components/common/PublicRoute';
import PrivateRoute from './components/common/PrivateRoute';
import Master from './components/layout/Master';
import { useAccess } from './components/hooks/useAccess';
import { DistinctArray } from './utils/helpers';
import { APIS } from './config/apis';
import { APPCONFIG } from './app.config';

function Router() {

    const dispatch = useDispatch();
    const isAuthenticated = useSelector( (state) => state.auth.isAuthenticated );
    
    const location = useLocation();
    // Otra web pasa la sesión con un código de un solo uso, nunca con el token en la dirección.
    const receivingSession = useSessionHandoff({
        sessionApi: APIS.URLS.SESION,
        loginUrl: APPCONFIG.SITE.WEBAPP_PRINCIPAL + 'logout',
        dispatch,
    });

    const [FilteredPrivateRoutes, setFilteredPrivateRoutes] = useState([
        PrivateRoutes.find(route => route.code === 'home'),
        PrivateRoutes.find(route => route.code === 'unauthorized')
    ]);

    let tempPrivateRoutes = [];
        
    const [ObtainedPrivateRoute, ready] = useAccess({
        key: (receivingSession ||
              location.pathname.endsWith('unauthorized')) ? '' : '_SecurityAccesses',
        onLoaded: (data, isSuccess, error) => {
            if (!isSuccess) {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
            }
        }
    });

    useEffect(() => {
        if (ready) {
            const AuxRoutes = ObtainedPrivateRoute.map(route => ({
                code: route.codigo,
                module:  route.modulo
            }));

            // Búsqueda de coincidencia por código de permiso.
            PrivateRoutes.filter(route => AuxRoutes.some(auxRoute => auxRoute.code === route.code)).forEach(route => tempPrivateRoutes.push(route));
                        
            // Inclusión de agrupadores según los códigos incluidos arriba.
            const groups = PrivateRoutes.filter(route => tempPrivateRoutes.some(r => route.children.find(c => c === r.index)));
            DistinctArray(groups.map(group => group.index)).forEach(index => {
                tempPrivateRoutes.push(PrivateRoutes.find(f => f.index === index));
            });
            
            tempPrivateRoutes.sort((a,b) => a.index - b.index);

            setFilteredPrivateRoutes(prevState => {
                const NotFoundRoute = PrivateRoutes.find(route => route.code === 'not-found');
                return [...prevState, NotFoundRoute, ...tempPrivateRoutes];
            });
        }
    }, [ready]);
    
    if (receivingSession) {
        return <></>;
    }

  return (
    <Routes>
    {
        PublicRoutes.map((route, indexr) => (
            Array.isArray(route.path) ?
                route.path.map((path, indexp) => (
                    <Route key={`${indexr}-${indexp}`}
                        path={path}
                        element={
                            <PublicRoute
                                isAuthenticated={isAuthenticated}
                                component={<Master showHeader={route.showHeader} component={route.component}
                                                   tipName={route.tipName} />}
                            />
                        }
                    />
                ))
            :
                <Route key={indexr}
                path={route.path}
                element={
                    <PublicRoute
                        isAuthenticated={isAuthenticated}
                        component={<Master showHeader={route.showHeader} component={route.component}
                                           tipName={route.tipName} />}
                    />
                }
        />
        ))
    }
    {
        FilteredPrivateRoutes.map((route, indexr) => (
            Array.isArray(route.path) ?
                route.path.map((path, indexp) => (
                    <Route key={`${indexr}-${indexp}`}
                        path={path}
                        element={
                            <PrivateRoute
                                isAuthenticated={isAuthenticated}
                                component={<Master showHeader={route.showHeader} component={route.component}
                                                   tipName={route.tipName} />}
                            />
                        }
                    />
                ))
            :
                <Route key={indexr}
                path={route.path}
                element={
                    <PrivateRoute
                        isAuthenticated={isAuthenticated}
                        component={<Master showHeader={route.showHeader} component={route.component}
                                           tipName={route.tipName} />}
                    />
                }
        />
        ))
    }
    </Routes>
  );
}

export default Router;
